var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 15,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-new_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new_icon",
    "data-name": "new icon",
    clipPath: "url(#clip-new_icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22976",
    "data-name": "Group 22976",
    transform: "translate(0.001 0.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M-12299.291-4068.954l3.576-1.179v3.122h3.282l-1.525,2.868,2.654,1.769-2.654,1.642,1.525,2.678-3.282.661v3.209l-3.576-1.412-1.527,2.606-1.566-2.606-3.279,1.412v-3.209h-3.271l1.386-3.339-2.839-1.642,2.839-1.769-1.386-2.868h3.271v-3.122l3.279,1.179,1.566-2.565Z",
    transform: "translate(12310.389 4071.519)",
    fill: "#fcaf3c"
  }), /*#__PURE__*/React.createElement("text", {
    id: "NEW",
    transform: "matrix(0.899, -0.438, 0.438, 0.899, 5.753, 12.491)",
    fill: "#fff",
    fontSize: 4,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEW"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewicon);
export default __webpack_public_path__ + "static/media/newicon.6024a91f964e89daf00891f7057d4319.svg";
export { ForwardRef as ReactComponent };